// extracted by mini-css-extract-plugin
var _1 = "MyBoxPage_container__5Q4dm";
export { _1 as "container" }
